// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._8Tp8XmfCw-8dHgnkqRTp_ {\n  letter-spacing: var(--striking-letter-spacing);\n  font-size: var(--striking-font-size);\n  text-align: center;\n  margin-bottom: var(--space-medium);\n}\n\n.g5f1KEWSRZFX-hWhHhVxN {\n  display: block;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  margin: 0 auto calc(var(--space-small) * 3);\n}\n\n.iK2saepW7SRxPnvMjQtbP {\n  color: var(--brown);\n}\n\n._2fTEfIo3vMRybOQxyAK2o0 {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
exports.locals = {
	"heading": "_8Tp8XmfCw-8dHgnkqRTp_",
	"logo": "g5f1KEWSRZFX-hWhHhVxN",
	"dot": "iK2saepW7SRxPnvMjQtbP",
	"snsList": "_2fTEfIo3vMRybOQxyAK2o0"
};
module.exports = exports;
